"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkspaceAccessRoles = void 0;
const react_1 = __importDefault(require("react"));
const client_1 = require("@apollo/client");
const ac_1 = require("@app/ac");
const store_1 = require("@app/store");
const error_handler_1 = require("@app/util/error-handler");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const accessRolesQuery = (0, client_1.gql) `
  query AccessRoles($workspaceId: ID!) {
    workspace(id: $workspaceId) {
      accessRoles {
        id
        name
        workspaceId
        assigns {
          userId
          created
        }
        permissions
        isDefaultAccessRoleEmployee
        isDefaultAccessRoleManager
        isDefaultForNewUsers
      }
    }
  }
`;
const useWorkspaceAccessRoles = () => {
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const dispatch = (0, store_1.useRootDispatch)();
    const { data, loading, refetch } = (0, client_1.useQuery)(accessRolesQuery, {
        variables: {
            workspaceId: workspace?.id ?? '',
        },
        onError: (error) => (0, error_handler_1.processErrors)((0, error_handler_1.reduceErrors)(error.graphQLErrors)),
    });
    react_1.default.useEffect(() => {
        void dispatch((0, ac_1.isLoading)('workspaceAccessRoles', !loading));
    }, [loading]);
    return { data: data?.workspace.accessRoles ?? [], refetch };
};
exports.useWorkspaceAccessRoles = useWorkspaceAccessRoles;
